module.exports = __webpack_public_path__ + "img/ivonaknaus.5db0b3d0.jpg";